const { projects } = require('../assets/info.json');
const images = {};

for (const item of projects) {
    images[item.id] = item.thumbnail ? require(`../assets/${item.thumbnail}`) : null;
}

module.exports = images;